// extracted by mini-css-extract-plugin
export default {"pagebutton":"CalculateButton_pagebutton__MV7xC"};